import { useAuth0 } from "@auth0/auth0-react";
import AlertDialog from "components/Dialog";
import MyButton from "components/MyButton";
import MyTable from "components/Table";
import FinanceService from "Lib/API/Finance";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import styled from "styled-components";
import { DateFormetContext } from "../../../app/App.js";
import { CheckFloatValue } from "../../../utils/functions.js";
import "../index.scss";
const Title = styled.div`
  font-size: 15px;
  color: #3f4255;
  margin-top: 24px;
  margin-inline-start: 39px;
`;
const NoRows = styled.div`
  font-size: 30px;
  color: #3f4255;
  margin-left: 10px;
`;

const PaymentsTable = ({ amount, toValue, ...props }) => {
  const dateFormet = React.useContext(DateFormetContext);
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = useState(1);
  const [list, setList] = React.useState([]);
  const [remaining, setRemaining] = React.useState(0);
  const { getAccessTokenSilently } = useAuth0();
  const [open, setOpen] = React.useState(false);
  const enableLoading = (value) => {
    setLoading(value);
  };
  const CustomNoRowsOverlay = () => {
    return (
      <div className="d-flex m-auto">
        <NoRows>{toValue ? "No Invoices" : "Please Choose a Member"}</NoRows>
      </div>
    );
  };
  useEffect(() => {
    const id = toValue?._id;
    async function fetchMyAPI() {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      await FinanceService.getInvoices(
        { filter: { member_id: id, status: "UnPaid" } },
        0,
        10000,
        token
      )
        .then((res) => {
          if (res?.invoices) {
            res.invoices.map((item) => {
              item.id = item._id;
              return item;
            });
            setList(res.invoices);
          } else setList([]);
          enableLoading(false);
        })
        .catch((err) => {
          enableLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    }

    if (id) fetchMyAPI();
  }, [getAccessTokenSilently, page, toValue]);

  const columns = [
    {
      field: "inv_id",
      resizable: true,
      headerName: "INVOICE NUMBER",
      minWidth: 150,
      flex: 1,
      sortable: true,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "#575757" }}>
          {data?.row?.inv_id || "-"}
        </div>
      ),
    },
    {
      field: "inv_due_date",
      resizable: true,
      headerName: "DATE",
      sortable: true,
      minWidth: 150,
      flex: 1,

      renderCell: (data) => {
        return (
          <div style={{ fontSize: "14px", color: "#575757" }}>
            {moment(data?.row?.inv_due_date)
              .utcOffset("+0100")
              .format(dateFormet)}
          </div>
        );
      },
    },

    {
      field: "total",
      resizable: true,
      headerName: "TOTAL",
      sortable: true,
      minWidth: 150,
      flex: 1,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "#4CAF50" }}>
          ${Math.round(data?.row?.payment_amount?.total) || "-"}
        </div>
      ),
    },
  ];

  const calculateTotal = () => {
    let sum = 0;
    if (selectionModel)
      selectionModel.forEach((item) => {
        if (list)
          list.forEach((row) => {
            if (row.id === item) sum += row?.payment_amount?.total;
          });
      });
    return CheckFloatValue(sum)
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const speedPay = () => {
    let arr = [];
    if (list)
      list.forEach((invoice) => {
        arr.push({
          dif: moment(invoice.inv_due_date).diff(moment(), "days"),
          invoice: invoice,
        });
      });
    const result = arr.sort(function (a, b) {
      return a.dif - b.dif;
    });
    let selected = [];
    let sum = 0;
    result.forEach((item) => {
      sum += item.invoice?.payment_amount?.total;
      if (sum <= amount) {
        selected.push(item.invoice?.id);
      } else sum -= item.invoice?.payment_amount?.total;
    });
    setRemaining(amount - sum);
    setSelectionModel(selected);
  };

  return (
    <div className="activated-ledger pt-5" style={{ display: "contents" }}>
      <div
        className="ledger-table"
        style={{ height: "fit-content", marginTop: 20, marginInlineEnd: 25 }}
      >
        <div style={{ display: "flex" }}>
          <Title>Payments</Title>
          <div
            className="issue-invoice-button"
            style={{
              display: "flex",
              marginTop: 20,
              justifyContent: "flex-start",
              alignItems: "flex-start",
              marginInlineStart: "auto",
              marginInlineEnd: 38,
            }}
          >
            <div className="button-container" style={{ marginInlineEnd: 15 }}>
              <MyButton
                style={{ backgroundColor: "#f8c20a" }}
                content="Speed Pay"
                onClick={speedPay}
              />
            </div>
            <div
              className="w-250px d-flex justify-content-between"
              style={{
                backgroundColor: "#99B7EF",
                borderRadius: "6px",
                height: "100%",
                alignItems: "center",
              }}
            >
              <div
                className="ml-5"
                style={{ fontSize: "15px", lineHeight: "1" }}
              >
                Remaining Amount
              </div>
              <div
                className="mr-5"
                style={{ fontWeight: "bolder", fontSize: "20px" }}
              >
                $
                {calculateTotal() > 0
                  ? amount - calculateTotal() > 0
                    ? CheckFloatValue(amount - calculateTotal())
                        ?.toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : 0
                  : 0}
              </div>
            </div>
          </div>
        </div>
        <div className="home-table-container mt-0">
          <MyTable
            className="family-table pb-0"
            rows={list}
            columns={columns}
            CustomNoRowsOverlay={CustomNoRowsOverlay}
            loading={loading}
            rowHeight={65}
            checkboxSelection
            disableSelectionOnClick
            onSelectionModelChange={(newSelectionModel) => {
              setSelectionModel(newSelectionModel);
            }}
            selectionModel={selectionModel}
            hideFooter
          />
          <div className="d-flex justify-content-between px-10">
            <p className="cal-footer">Total</p>
            <p className="cal-footer">${calculateTotal()}</p>
          </div>
          <div className="d-flex justify-content-end pr-10 pb-10">
            <MyButton
              disabled={selectionModel.length <= 0 || !props.valid}
              style={{ width: "150px" }}
              loading={false}
              content="Pay"
              type="submit"
              onClick={() => {
                selectionModel.length > 0 && setOpen(true);
                props.setSubmit(true);
                setTimeout(() => {
                  props.setSubmit(false);
                }, 1000);
              }}
            />
            <AlertDialog
              open={open}
              handleClose={() => setOpen(false)}
              onDecline={() => {
                setOpen(false);
              }}
              onAccept={() => {}}
              title={"Are you sure?"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentsTable;
